module.exports = __webpack_public_path__ + "img/1-Porcion de la RNCOM.d410c5d7.png";